import isNil from 'ramda/src/isNil';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Color } from '~common/model/basics';
import { Portal } from '~web/view/components/core/portal.component';
import { Backdrop } from '~web/view/components/layout/backdrop.component';
import { Box } from '~common/components/box.component';

export interface ModalProps {
  disableBackdropClick?: boolean;
  backdropColor?: Color;
  backdropColorAlpha?: number;
  onCancel?: () => void;
  onShow?: VoidFunction;
}

export const Modal: React.FunctionComponent<ModalProps> = ({
  children,
  disableBackdropClick,
  backdropColor,
  backdropColorAlpha,
  onCancel,
  onShow,
  ...rest
}) => {
  useEffect(() => {
    onShow?.();
  }, []);

  const handleBackdropClick = (): void => {
    if (!disableBackdropClick) {
      if (!isNil(onCancel)) {
        onCancel();
      }
    }
  };

  return (
    <Portal>
      <Container role={'presentation'} {...rest}>
        <Backdrop
          backgroundColor={backdropColor}
          backdropColorAlpha={backdropColorAlpha}
          onClick={handleBackdropClick}
        />
        {children}
      </Container>
    </Portal>
  );
};

const Container = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${(props): number => props.theme.zIndex.modal};
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/layout/modal.component.tsx